import {writable} from 'svelte/store';
import {I_PERSON_COMPANY} from "../../../../../lib/datatypes";

import {companies} from "./companies";

export const person_company = writable({
    list: [],
});
export const person_company_fetching = writable(false);

let $person_company = null;
const a_unsubscribe = person_company.subscribe(val => $person_company = val);

let $companies = null;
const b_unsubscribe = companies.subscribe(val => $companies = val);


const _updateStructures = person_company => {};

// Explicitly set the contents of people by passing them in, ie from bootstrapped data
export const setPersonCompany = data => {
    person_company.update(person_company => {
        person_company.list = data;
        // _updateStructures(person_company);
        return person_company;
    });
};

export const loadPersonCompany = async () => {
    person_company_fetching.set(true);

    const response = await fetch(`/api/person-company`);
    let result = await response.json();
    person_company_fetching.set(false);
    person_company.update(person_company => {
        person_company.list = result;
        _updateStructures(person_company);
        return person_company;
    });
};


export const getPersonCompanyForPerson = person_id => {
    return $person_company.list.filter(o => o[I_PERSON_COMPANY.ID_PERSON] === person_id);
};
const getForCompany = company_id => {};

export const addPersonCompaniesForPerson = async (person_id, person_company_arr_list) => {
    let payload = person_company_arr_list.map(o => {
        o[I_PERSON_COMPANY.ID_PERSON] = person_id;
        return o;
    });
    return await updatePersonCompanies(person_id, person_company_arr_list);
};
export const updatePersonCompanies = async (person_id, person_company_arr_list) => {
    person_company_fetching.set(true);

    const url = `/api/person-company`;
    const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
            person_id: typeof person_id !== 'string' ? person_id.toString() : person_id,
            list: person_company_arr_list
        })
    });
    let result = await response.json();
    person_company_fetching.set(false);
    person_company.update(person_company => {

        // NB brute-force - get list without any entries for person, add the provided items to it
        // (rather than trying to edit, splice, etc as none of the entries have their own unique id or anything..)
        let list_without_person = person_company.list.filter(item => item[I_PERSON_COMPANY.ID_PERSON] != person_id);
        result.forEach(item => list_without_person.push(item));
        person_company.list = list_without_person;

        // _updateStructures(person_company); // NB uncomment if we need to do any post-processing of data for store purposes
        return person_company;
    });
    return result;
};

